<template>
    <Modal
        :title="$t('insights.usersWithoutOKRs')"
        :okTitle="$t('modal.close')"
        okVariant="secondary"
        isModalRoute
        okOnly
    >
        <Loader :loader="loader" />
        <ListUsers v-show="!loader" :users="users">
            <template slot-scope="{ id }">
                <ToUserProfile :id="id" />
            </template>
        </ListUsers>
    </Modal>
</template>

<script>
import api from '@/services/api'
import Modal from '@/views/components/modal'
import Loader from '@/views/components/loader'
import ListUsers, { ToUserProfile } from './components/list-users'

export default {
    name: 'UsersWithoutOKRs',
    components: {
        Modal,
        ListUsers,
        ToUserProfile,
        Loader,
    },
    data() {
        return {
            users: [],
            loader: true,
        }
    },
    mounted() {
        api.get('/dashboard/users-without-okrs')
            .then(({ data: { data } }) => {
                this.users = data
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loader = false
            })
    },
    destroyed() {
        this.$emit('modalClosed')
    },
}
</script>
